module.exports = __webpack_public_path__ + "img/10.ff6311f2.png";